<template>
  <div class="space-y-4">
    <h2>{{ t('minAges') }}</h2>
    <MultipleValuesListField
      name="minAges"
      :button-text="t('addMinAgeStep')"
      :field-settings="fieldSettings"
      show-delete-alert
    />
  </div>
</template>

<script lang="ts" setup>
import MultipleValuesListField, {
  type FieldSettings,
} from '@/components/MultipleValuesListField.vue';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

const { t } = useI18n();

const fieldSettings = computed<FieldSettings[]>(() => [
  {
    name: 'netPurchasePriceLt',
    label: t('netPurchasePriceLt'),
    placeholder: '∞',
    type: 'number',
    adornment: '€',
  },
  {
    name: 'minAge',
    label: t('minAge'),
    type: 'number',
  },
]);
</script>

<i18n lang="json">
{
  "en": {
    "minAges": "Min ages",
    "addMinAgeStep": "+ Add min age step",
    "netPurchasePriceLt": "Net purchase price less than",
    "minAge": "Min age"
  },
  "de": {
    "minAges": "Mindestalter",
    "addMinAgeStep": "+ Mindestalterstaffelung hinzufügen",
    "netPurchasePriceLt": "Netto EK kleiner als",
    "minAge": "Mindestalter"
  },
  "es": {
    "minAges": "Edades mínimas",
    "addMinAgeStep": "+ Añadir tramo de edad mínima",
    "netPurchasePriceLt": "Precio neto de compra inferior a",
    "minAge": "Edad mínima"
  }
}
</i18n>
